import React, { useEffect } from "react";
import classNames from "classnames";
import styles from "./Modal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../redux/modalStore";
import OutsideClickHandler from "react-outside-click-handler";
import { X } from "lucide-react";

const Modal = ({
  name,
  children,
  title,
  subtitle,
  width,
  minWidth,
  maxWidth,
  height,
  onClose,
  isPopupOpen,
  headerAction,
}) => {
  const openedModal = useSelector((state) => state.modal.openedModal);
  const dispatch = useDispatch();

  // Content behind modal can't be scrolled while modal is opened
  useEffect(() => {
    if (openedModal?.name === name) {
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [openedModal?.name, name]);

  const handleCloseModal = () => {
    if (onClose) {
      onClose();
      return;
    }

    if (!isPopupOpen) {
      dispatch(hideModal());
    }
  };

  const hasHeaderContent = Boolean(title) || Boolean(subtitle);

  return openedModal?.name === name ? (
    <div className={styles.modal} data-modal-name={name}>
      <OutsideClickHandler
        onOutsideClick={(event) => {
          const isIgnoredClick = event?.target?.closest(
            "[data-ignore-outside-click]",
          );
          if (isIgnoredClick) return; // don't close modal

          handleCloseModal();
        }}
        disabled={isPopupOpen}
      >
        <div
          className={classNames(styles.header, {
            [styles.headerCompact]: !hasHeaderContent,
          })}
          data-modal-header
          style={{
            width: width,
            minWidth: minWidth,
            maxWidth: maxWidth,
          }}
        >
          {hasHeaderContent && (
            <div className={styles.titleGroup}>
              <div className={styles.title}>{title}</div>
              {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
            </div>
          )}
          <div className={styles.rightSide}>
            {headerAction && <div>{headerAction}</div>}
            <button
              type="button"
              className={styles.closeButton}
              onClick={handleCloseModal}
              aria-label="Close"
              data-modal-close
            >
              <X size={16} />
            </button>
          </div>
        </div>
        <div
          className={styles.box}
          data-modal-box
          style={{
            width: width,
            minWidth: minWidth,
            maxWidth: maxWidth,
            height: height,
          }}
        >
          <div className={styles.children}>{children}</div>
        </div>
      </OutsideClickHandler>
    </div>
  ) : (
    ""
  );
};

export default Modal;
